// Какие виды POI рисуются на карте: группа отмечена в меню «Слои» и зум не
// меньше POI_DETAIL_MIN_ZOOM. Применяется в usePoiLayers.ts::refreshPoiClusterSource ДО
// кластеризации: скрытые виды не должны попадать в источник, иначе они
// раздувают чипы кластеров, даже будучи невидимыми по отдельности.
//
// peak/mountain_pass (свой слой) и mountain_rescue/rescue_hut (пины) сюда не входят -
// они не проходят через кластерный источник и видны всегда.

// Группы для меню «Слои» - одна галочка на смысловую группу, а не на каждый
// OSM-тег. Галочка - просто вкл/выкл: отмечена - группа рисуется по общему
// правилу детализации (с POI_DETAIL_MIN_ZOOM), снята - не рисуется вовсе.
// defaultOn - что отмечено у нового пользователя (все группы).
export const POI_GROUPS: ReadonlyArray<{ id: string; kinds: readonly string[]; defaultOn: boolean }> = [
  {
    id: "stayWater",
    kinds: ["camp_site", "alpine_hut", "wilderness_hut", "spring", "drinking_water", "water_well", "water_tap", "water_point", "waterfall"],
    defaultOn: true,
  },
  { id: "obstacles", kinds: ["ford"], defaultOn: true },
  { id: "rest", kinds: ["shelter", "firepit", "picnic_table"], defaultOn: true },
  { id: "viewpoint", kinds: ["viewpoint"], defaultOn: true },
  { id: "amenities", kinds: ["toilets", "waste_basket", "waste_disposal"], defaultOn: true },
];

// С этого зума видны все точки включённых групп (совпадает с POI_LOD_MIN_ZOOM).
export const POI_DETAIL_MIN_ZOOM = 13;

export const defaultPoiGroups = (): string[] => POI_GROUPS.filter((g) => g.defaultOn).map((g) => g.id);

export const kindsOfGroups = (groupIds: Iterable<string>): Set<string> => {
  const wanted = new Set(groupIds);
  const kinds = new Set<string>();
  for (const group of POI_GROUPS) {
    if (wanted.has(group.id)) group.kinds.forEach((k) => kinds.add(k));
  }
  return kinds;
};

const GROUPED_KINDS: ReadonlySet<string> = kindsOfGroups(POI_GROUPS.map((g) => g.id));

// Вид из меню «Слои» рисуется, только если его группа отмечена, и только с
// POI_DETAIL_MIN_ZOOM. Виды вне групп (башни, пещеры, скалы, станции
// канатных дорог) в меню не представлены и рисуются по одному правилу зума.
export const isPoiKindVisible = (kind: string, zoom: number, enabledKinds: ReadonlySet<string>): boolean =>
  zoom >= POI_DETAIL_MIN_ZOOM && (!GROUPED_KINDS.has(kind) || enabledKinds.has(kind));
